import { getApiUrl } from "../utils/general.js";
import axios from "axios";

const LevelOpexService = {
  // Metodi per recuperare i raggruppamenti (compatibilità con OpexTable)

  // Raggruppamento 1 (Level 1)
  getRaggruppamento1: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level1/getlevels1`);
      // Mappiamo i dati del livello 1 al formato atteso da OpexTable
      return data.map((item) => ({
        ragg1_code: item.level1_code,
        ragg1_desc: item.level1_desc,
      }));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Raggruppamento 2 (Level 2)
  getRaggruppamento2: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level2/getlevels2`);
      // Mappiamo i dati del livello 2 al formato atteso da OpexTable
      return data.map((item) => ({
        ragg2_code: item.level2_code,
        ragg2_desc: item.level2_desc,
      }));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Raggruppamento 3 (Level 3)
  getRaggruppamento3: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level3/getlevels3`);
      // Mappiamo i dati del livello 3 al formato atteso da OpexTable
      return data.map((item) => ({
        ragg3_code: item.level3_code,
        ragg3_desc: item.level3_desc,
      }));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Raggruppamento 2 filtrato per Raggruppamento 1
  getRaggruppamento2ByRagg1: async (ragg1Code) => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/level2/getlevel2bylevel1?level1Code=${ragg1Code}`
      );
      // Mappiamo i dati del livello 2 al formato atteso da OpexTable
      return data.map((item) => ({
        ragg2_code: item.level2_code,
        ragg2_desc: item.level2_desc,
      }));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Raggruppamento 3 filtrato per Raggruppamento 2
  getRaggruppamento3ByRagg2: async (ragg2Code) => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/level3/getlevel3bylevel2?level2Code=${ragg2Code}`
      );
      // Mappiamo i dati del livello 3 al formato atteso da OpexTable
      return data.map((item) => ({
        ragg3_code: item.level3_code,
        ragg3_desc: item.level3_desc,
      }));
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // METODI ORIGINALI
  // Level 1 endpoints
  getLevels1: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level1/getlevels1`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateLevel1: async (levelData) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/level1/updatelevel1`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertLevel1: async (levelData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/level1/insertlevel1`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteLevel1: async (levelId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/level1/deletelevel1?id=${levelId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Level 2 endpoints
  getLevels2: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level2/getlevels2`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateLevel2: async (levelData) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/level2/updatelevel2`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertLevel2: async (levelData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/level2/insertlevel2`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteLevel2: async (levelId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/level2/deletelevel2?id=${levelId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Level 3 endpoints
  getLevels3: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/level3/getlevels3`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateLevel3: async (levelData) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/level3/updatelevel3`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertLevel3: async (levelData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/level3/insertlevel3`,
        levelData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteLevel3: async (levelId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/level3/deletelevel3?id=${levelId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Metodi aggiuntivi per le relazioni tra livelli
  getLevels2ByLevel1: async (level1Code) => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/level2/getlevel2bylevel1?level1Code=${level1Code}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  getLevels3ByLevel2: async (level2Code) => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/level3/getlevel3bylevel2?level2Code=${level2Code}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  getAccountsConfiguration: async () => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/configurazionicontiopex/getconfigurazionicontiopex`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateAccountsConfiguration: async (payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/configurazionicontiopex/updateconfigurazioniconti`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertAccountsConfiguration: async (payload) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/configurazionicontiopex/insertconfigurazioniconti`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteAccountsConfiguration: async (id) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/configurazionicontiopex/deleteconfigurazioniconti?id=${id}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
  getCDCConfigurations: async () => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/configurazionecdcopex/getconfigurazionecdc`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertCDCConfiguration: async (payload) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/configurazionecdcopex/insertconfigurazionecdc`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteCDCConfiguration: async (id) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/configurazionecdcopex/deleteconfigurazionecdc?id=${id}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateCDCConfiguration: async (payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/configurazionecdcopex/updateconfigurazionecdc`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  getExpenseItemsConfigurations: async () => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/configurazionevocispeseopex/getconfigurazionevocispese`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertExpenseItemsConfiguration: async (payload) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/configurazionevocispeseopex/insertconfigurazionevocispese`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteExpenseItemsConfiguration: async (id) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/configurazionevocispeseopex/deleteconfigurazionevocispese?id=${id}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateExpenseItemsConfiguration: async (payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/configurazionevocispeseopex/updateconfigurazionevocispese`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
};

export default LevelOpexService;
